
  export const environment = {
    production: true,
    apiUrl: 'https://vfxgiorapi.azurewebsites.net/api',
    functionsUrl: 'https://vfxgior.azurewebsites.net/api',
    hide6fAppData: false,
    hideNews: true,
    mapId: 'f33257edfefa7f3a'
  };